import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { USER_TYPE } from "@/types/enum";
import { getAllowedRoutes } from "@/utils/permissions";
import { useMemo } from "react";
import { matchPath, Navigate, useLocation } from "react-router-dom";

export const RoleGuard: FCC = ({ children }) => {
  const { userType } = useInitSetup();
  const { pathname } = useLocation();

  const isAllowed = useMemo(() => {
    if (!userType) return true;
    if (userType === USER_TYPE.RSO_USER) return true;

    const allowedRoutes = getAllowedRoutes(userType);
    return allowedRoutes.some((route) => matchPath(route, pathname));
  }, [userType, pathname]);

  if (!isAllowed) {
    return <Navigate to={AppRoutes.home} replace />;
  }

  return <>{children}</>;
};
